// Angular
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'kt-update-entity-dialog',
	templateUrl: './update-entity-dialog.component.html',
  styleUrls: ['../modal.scss']
})
export class UpdateEntityDialogComponent implements OnInit {
	// Public properties
	viewLoading: boolean = false;
	waitTime: number = 2500;
	/**
	 * Component constructor
	 *
	 * @param dialogRef: MatDialogRef<UpdateEntityDialogComponent>
	 * @param data: any
	 */
	constructor(
		public dialogRef: MatDialogRef<UpdateEntityDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		if(this.data.hasOwnProperty('waitTime')){
			this.waitTime = this.data.waitTime;
		}
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
	}

	/**
	 * Close dialog with false result
	 */
	onNoClick(): void {
		this.dialogRef.close();
	}

	/**
	 * Close dialog with true result
	 */
	onYesClick(): void {
		/* Server loading imitation. Remove this */
		this.viewLoading = true;
		setTimeout(() => {
			this.dialogRef.close(true); // Keep only this row
		}, this.waitTime);
	}
}
